import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=653afb86&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653afb86')) {
      api.createRecord('653afb86', component.options)
    } else {
      api.reload('653afb86', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=653afb86&", function () {
      api.rerender('653afb86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4njsdLpCYcKIh/JS/comp/stardisplay.vue"
export default component.exports